export const LOCALE = {
  enUS: 'en-us'
};
export const NAV_ITEM_ID = {
  about: 'about',
  accessibility: 'accessibility',
  accountSettings: 'account-settings',
  partnerAccountSettings: 'partner-account-settings',
  blog: 'blog',
  billing: 'billing',
  contact: 'contact',
  cookie: 'cookie',
  customerSolutions: 'customer-solutions',
  datasets: 'datasets',
  deploymentKeys: 'deployment-keys',
  documentation: 'documentation',
  partnerDocumentation: 'partner-documentation',
  enterpriseSolutions: 'enterprise-solutions',
  feedback: 'feedback',
  invoices: 'invoices',
  internationalSelling: 'international-selling',
  learnMore: 'learn-more',
  legal: 'legal',
  logout: 'logout',
  marketplace: 'marketplace',
  myAccount: 'my-account',
  myDashboard: 'my-dashboard',
  usage: 'usage',
  myClusters: 'my-clusters',
  myCompany: 'my-company',
  myRequests: 'my-requests',
  mySoftware: 'my-software',
  access: 'access',
  myTeam: 'my-team',
  serviceIds: 'service-ids',
  partnerServiceIds: 'partner-service-ids',
  partnerAccess: 'partner-access',
  partnerMyTeam: 'partner-my-team',
  myUpdates: 'my-updates',
  myOffers: 'my-offers',
  partnerExperience: 'partner-experience',
  paymentSettings: 'payment-settings',
  paymentMethod: 'payment-method',
  pendingCharges: 'pending-charges',
  performance: 'performance',
  privateOffers: 'private-offers',
  partnerProducts: 'partner-products',
  manageOffers: 'manage-offers',
  privacy: 'privacy',
  profile: 'profile',
  partnerProfile: 'partner-profile',
  signIn: 'sign-in',
  support: 'support',
  systemStatus: 'system-status',
  terms: 'terms',
  rhmTerms: 'rhm-terms',
  workspace: 'workspace',
  marketplaceSelect: 'marketplace-select',
  marketplaceSelectCustomization: 'marketplace-select-customization-editor',
  marketplaceSelectTagManagement: 'marketplace-select-tag-management',
  credits: 'credits',
  catalog: 'catalog',
  localeSelector: 'locale-selector'
};
export const PATH_TYPE = {
  absolute: 'absolute',
  relative: 'relative'
};
export const TARGET = {
  blank: '_blank',
  parent: '_parent',
  self: '_self',
  top: '_top'
};
export const NAV_SECTIONS = {
  account: 'account',
  workspace: 'workspace',
  partner: 'partner'
};
export default {
  LOCALE,
  NAV_ITEM_ID,
  PATH_TYPE,
  TARGET,
  NAV_SECTIONS
};